<!-- Groups Sicuro centrale Modal @show="tableGroups" modal-class="custom-modal-top" -->
<template>
    <b-modal
      :visible="visible" 
      @hidden="hide"
      @change="change"
      @ok="inizializzaStato"
      @shown="verificaResponse"
      ok-only
      :no-close-on-backdrop="true"
      scrollable
      ref="modal"      
      id="modal-groups-cu"
      :title="getTitle"
      size="xl"
    >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <span :style="{ color: '#04709C' }">
          {{ getTitle }}
        </span>
        <b-button variant="primary" @click="addNewGroup" class="mb-0 ml-5">
          {{$t('assign_group_button.text')}}
        </b-button>
        <b-spinner v-if="waiting" variant="primary" :style="{ marginLeft: '10rem' }" label="Loading..."></b-spinner>
      </div>
    </template>

      <b-container>
        <!-- attivo il rendering solo se currentCent è già stato valorizzato -->
        <b-row v-if="currentCent != null"> 
          <b-col
            v-for="(group, index) in currentCent.groups"
            :key="index"
            cols="12"
            md="6"
            lg="4"
            class="mb-4"
          >
          <!-- visualizzazione/modifica delle schede di gruppo  -->
            <b-card 
              no-body
              header-bg-variant="light">
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <!-- <span v-if="editingGroup && (editingGroupIndex === group.groupId)">
                  <b-form-group :label="$t('groups_cu_modal.index_group')" label-for="group-select" label-class="font-weight-bold">
                    <multiselect
                      id="group-select"
                      v-model="selectedIndex"
                      :options="getGroupOptions(group.groupId)"
                      :placeholder= "$t('configura_lamp_modal.select_index')"
                      label="text"
                      track-by="value"
                      :searchable="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :max-height="200"
                      >
                    </multiselect>  
                  </b-form-group>
                </span>
                <span v-else>
                  <h5 class="mb-0">{{ $t('groups_cu_modal.group', {id: parseInt(group.groupId)}) }}</h5>
                </span> -->
                <span>
                  <h5 class="mb-0">{{ $t('groups_cu_modal.group', {id: parseInt(group.groupId)}) }}</h5>
                </span>
                <div v-if="editingGroup && (editingGroupIndex === group.groupId)">
                  <b-button size="sm" @click="saveGroup(group)">
                    <i class="fa fa-check" />
                  </b-button>
                  <b-button size="sm" class="ml-3" @click="editingGroup = false; editingGroupIndex = null;">
                    <i class="fa fa-times" />
                  </b-button>
                </div>
                <div v-else>
                  <b-button size="sm" @click="modifyGroup(group)">
                    <i class="fa fa-pencil" />
                  </b-button >
                  <b-button size="sm" class="ml-3" @click="deleteGroup(group)">
                    <i class="fa fa-trash" />
                  </b-button>
                </div>
              </div>
            </template>                      
              <b-list-group flush>
                <b-list-group-item>
                  <strong>{{$t('groups_cu_modal.group_desc')}}</strong>
                  <br>
                  <span v-if="editingGroup && (editingGroupIndex === group.groupId)">
                    <b-form-input
                        id="desc-group"
                        v-model="descGroup"
                        aria-describedby="desc-help">                     
                    </b-form-input>
                  </span> 
                  <span v-else>{{ group.group_desc }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>{{$t('groups_cu_modal.program')}}</strong>
                  <br>
                  <span v-if="editingGroup && (editingGroupIndex === group.groupId)">
                    <b-form-radio-group
                      id="function-modify"
                      v-model="selectedFunction"
                      :options="functionOptions"
                      name="functions"
                      stacked
                      aria-describedby="function-help"
                      role="radiogroup"
                    />
                  </span>
                  <span v-else>{{ group.program }}</span>                  
                </b-list-group-item>
                <b-list-group-item>
                  <strong>{{ $t('groups_cu_modal.subProgram') }}</strong>
                  <br>
                  <div v-if="editingGroup && (editingGroupIndex === group.groupId)">
                    <div v-if="selectedFunction === 'time switch'">
                      <b-form-radio-group
                        id="timeswitch-modify"
                        v-model="selectedTimeSwitch"
                        :options="timeswitchOptions"
                        name="time_switch"
                        stacked
                        aria-describedby="time-switch-help"
                        role="radiogroup"
                      />
                    </div>
                    <div v-else-if="selectedFunction === 'stairway pushbutton'">
                      <b-form-group :label="$t('configura_lamp_modal.select_starway_pushbutton')" label-for="starway-pushbutton-selection" label-class="font-weight-bold">
                        <multiselect
                          id="starway-pushbutton-selection"
                          v-model="selectedStairwayPushbutton"
                          :options="stairwaypushbuttonOptions"
                          :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                          label="text"
                          track-by="value"
                          :searchable="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :max-height="200">
                        </multiselect>  
                      </b-form-group>
                      <b-form-group :label="$t('configura_lamp_modal.select_sp_duration')" label-for="stairway-pushbutton-duration" label-class="font-weight-bold">
                        <multiselect
                          id="stairway-pushbutton-duration"
                          v-model="stairwaypushbuttonDuration"
                          :options="spdurationOptions"
                          :placeholder= "$t('configura_lamp_modal.select_duration')"
                          label="text"
                          track-by="value"
                          :searchable="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :max-height="200">
                        </multiselect>
                      </b-form-group>
                    </div>
                    <div v-else-if="selectedFunction === 'switchable'">
                      <!-- seleziona light switch -->
                      <b-form-group :label="$t('configura_lamp_modal.select_light_switch')" label-for="lightswitch-selection" label-class="font-weight-bold font-italic">
                        <multiselect
                          id="lightswitch-selection"
                          v-model="selectedLightswitch"
                          :options="lightswitchOptions"
                          :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                          :selectLabel="$t('configura_lamp_modal.press_enter')"
                          :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                          label="text"
                          track-by="value"
                          :searchable="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :max-height="200"
                          :multiple="true"
                          :max="4">
                          <template slot="noResult">
                            <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                          </template>
                          <template slot="noOptions">
                            <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                          </template>
                          <!-- personalizziamo le opzioni selezionate (tag) -->
                          <template slot="tag" slot-scope="props">
                              <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                                <span class="custom-tag badge badge-primary mr-1">
                                  <span>{{ props.option.text }}</span>
                                  <span class="custom-remove" @click="props.remove(props.option)">x</span>
                              </span>
                          </template>
                          <template slot="maxElements">
                              <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                          </template>
                        </multiselect>
                      </b-form-group>
                      <!-- seleziona sub distribution -->
                      <b-form-group :label="$t('configura_lamp_modal.select_sub_distribution')" label-for="subdistribution-selection" label-class="font-weight-bolder font-italic">
                        <multiselect
                          id="subdistribution-selection"
                          v-model="selectedSubdistribution"
                          :options="subdistributionOptions"
                          :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                          :selectLabel="$t('configura_lamp_modal.press_enter')"
                          :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                          label="text"
                          track-by="value"
                          :searchable="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :max-height="200"
                          :multiple="true"
                          :max="4">
                          <template slot="noResult">
                            <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                          </template>
                          <template slot="noOptions">
                            <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                          </template>
                          <!-- personalizziamo le opzioni selezionate (tag) -->
                          <template slot="tag" slot-scope="props">
                              <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                                <span class="custom-tag badge badge-primary mr-1">
                                  <span>{{ props.option.text }}</span>
                                  <span class="custom-remove" @click="props.remove(props.option)">x</span>
                              </span>
                          </template>
                          <template slot="maxElements">
                              <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                          </template>
                        </multiselect>
                      </b-form-group>
                      <!-- seleziona dynamic light -->
                      <b-form-group :label="$t('configura_lamp_modal.select_dynamic_light')" label-for="dynamiclight-selection" label-class="font-weight-bolder font-italic">
                        <multiselect
                          id="dynamiclight-selection"
                          v-model="selectedDynamiclight"
                          :options="dynamiclightOptions"
                          :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                          :selectLabel="$t('configura_lamp_modal.press_enter')"
                          :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                          label="text"
                          track-by="value"
                          :searchable="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :max-height="200"
                          :multiple="true"
                          :max="4">
                          <template slot="noResult">
                            <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                          </template>
                          <template slot="noOptions">
                            <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                          </template>
                          <!-- personalizziamo le opzioni selezionate (tag) -->
                          <template slot="tag" slot-scope="props">
                              <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                                <span class="custom-tag badge badge-primary mr-1">
                                  <span>{{ props.option.text }}</span>
                                  <span class="custom-remove" @click="props.remove(props.option)">x</span>
                              </span>
                          </template>
                          <template slot="maxElements">
                              <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                          </template>
                        </multiselect>
                      </b-form-group>
                      <!-- seleziona manual reset -->
                      <b-form-group :label="$t('configura_lamp_modal.select_manual_reset')" label-for="manualreset-selection" label-class="font-weight-bolder font-italic">
                        <multiselect
                          id="manualreset-selection"
                          v-model="selectedManualreset"
                          :options="manualresetOptions"
                          :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                          :selectLabel="$t('configura_lamp_modal.press_enter')"
                          :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                          label="text"
                          track-by="value"
                          :searchable="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :max-height="200"
                          :multiple="true"
                          :max="4">
                          <template slot="noResult">
                            <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                          </template>
                          <template slot="noOptions">
                            <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                          </template>
                          <!-- personalizziamo le opzioni selezionate (tag) -->
                          <template slot="tag" slot-scope="props">
                              <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                                <span class="custom-tag badge badge-primary mr-1">
                                  <span>{{ props.option.text }}</span>
                                  <span class="custom-remove" @click="props.remove(props.option)">x</span>
                              </span>
                          </template>
                          <template slot="maxElements">
                              <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                          </template>
                        </multiselect>
                      </b-form-group>                                                
                    </div>
                  </div>
                  <ul v-else class="list-unstyled">
                      <li v-for="(value, key) in group.subProgram" :key="key">
                        <div v-if="key.toUpperCase() === 'TIME'">
                          {{ key.toUpperCase() }}: {{ value }} sec
                        </div>
                        <div v-else>
                          {{ key.toUpperCase() }}: {{$t('lssa.lssa_address')}} {{ value }}
                        </div>
                      </li>
                  </ul>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-col>           
        </b-row>
      </b-container>

      <!-- modal per l'inserimento di un nuovo gruppo -->
      <b-modal 
        ref="modal-newgroup"
        id="modal-newgroup"
        v-model="showNewGroup"
        :hide-footer="footer_hide" 
        :title="$t('groups_cu_modal.sicurotitle')" 
        :ok-title="$t('groups_cu_modal.ok_button')" 
        @ok="handleOk"
        :ok-disabled="disabilitaOk()"
        @change="change"
        aria-describedby="modal-description"
        @shown="inizializzaStato"
        @hide="onModalNewGroupHide"
        @close="onModalNewGroupHide"
      >
        <template #modal-cancel>
          <b-button variant="secondary" @click="handleCancel">{{ $t('cancel') }}</b-button>
        </template>
        <template #modal-header-close>
          <b-button variant="secondary" @click="handleCancel"><strong>x</strong></b-button>
        </template>

        <b-container>
          <p id="modal-description" class="sr-only">
              {{ $t('configura_lamp_modal.spiega_modal') }}
          </p>
          <b-row align-h="center">
            <b-col cols="12">
              <b-card
                border-variant="primary"
                header-bg-variant="light"
                header-text-variant="dark"
                class="mb-3"
              >
                <!-- Seleziona l'indice di gruppo, tra quelli ancora disponibili -->
                <b-form-group :label="$t('groups_cu_modal.index_group')" label-for="group-select" label-class="font-weight-bold">
                  <multiselect
                    id="group-select"
                    v-model="selectedIndex"
                    :options="groupOptions"
                    :placeholder= "$t('configura_lamp_modal.select_index')"
                    label="text"
                    track-by="value"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :max-height="200"
                    @input="imponiDesc(selectedIndex)">
                  </multiselect>  
                </b-form-group>
                <!-- Inserisci description -->
                <b-form-group v-if="selectedIndex != null" :label="$t('groups_cu_modal.insert_desc')" label-for="desc-select" label-class="font-weight-bold">
                  <b-form-input
                    id="desc-select"
                    v-model="descGroup"
                    aria-describedby="desc-help"
                  />
                  <small id="desc-help" class="form-text text-muted sr-only">
                    {{ $t('groups_cu_modal.group_desc_help') }}
                  </small>
                </b-form-group>
                <b-form-group v-if="descGroup != null" :label="$t('configura_lamp_modal.select_function')" label-for="function-select" label-class="font-weight-bold">
                  <b-form-radio-group
                    id="function-select"
                    v-model="selectedFunction"
                    :options="functionOptions"
                    name="functions"
                    stacked
                    aria-describedby="function-help"
                    role="radiogroup"
                  />
                  <small id="function-help" class="form-text text-muted sr-only">
                    {{ $t('configura_lamp_modal.select_function_help') }}
                  </small>
                </b-form-group>

                <!-- Seleziona time switch -->
                <b-form-group v-if="selectedFunction === 'time switch'" :label="$t('configura_lamp_modal.select_time_switch')" label-for="timeswitch-selection" label-class="font-weight-bold">
                  <b-form-radio-group
                    id="timeswitch-selection"
                    v-model="selectedTimeSwitch"
                    :options="timeswitchOptions"
                    name="time_switch"
                    stacked
                    aria-describedby="time-switch-help"
                    role="radiogroup"
                  />
                  <small id="function-help" class="form-text text-muted sr-only">
                    {{ $t('configura_lamp_modal.select_timeswitch_help') }}
                  </small>
                </b-form-group>
                <!-- Seleziona stairway pushbutton -->
                <b-form-group v-if="selectedFunction === 'stairway pushbutton'" :label="$t('configura_lamp_modal.select_starway_pushbutton')" label-for="starway-pushbutton-selection" label-class="font-weight-bold">
                  <multiselect
                    id="starway-pushbutton-selection"
                    v-model="selectedStairwayPushbutton"
                    :options="stairwaypushbuttonOptions"
                    :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                    label="text"
                    track-by="value"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :max-height="200">
                  </multiselect>  
                </b-form-group>
                <b-form-group v-if="selectedStairwayPushbutton != null" :label="$t('configura_lamp_modal.select_sp_duration')" label-for="stairway-pushbutton-duration" label-class="font-weight-bold">
                  <multiselect
                    id="stairway-pushbutton-duration"
                    v-model="stairwaypushbuttonDuration"
                    :options="spdurationOptions"
                    :placeholder= "$t('configura_lamp_modal.select_duration')"
                    label="text"
                    track-by="value"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :max-height="200">
                  </multiselect>
                </b-form-group>
                <!-- Seleziona switchable -->
                <b-form-group v-if="selectedFunction === 'switchable'" :label="$t('configura_lamp_modal.select_switchable')" label-class="font-weight-bold">
                  <!-- seleziona light switch -->
                  <b-form-group :label="$t('configura_lamp_modal.select_light_switch')" label-for="lightswitch-selection" label-class="font-weight-bold font-italic">
                    <multiselect
                      id="lightswitch-selection"
                      v-model="selectedLightswitch"
                      :options="lightswitchOptions"
                      :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                      :selectLabel="$t('configura_lamp_modal.press_enter')"
                      :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                      label="text"
                      track-by="value"
                      :searchable="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :max-height="200"
                      :multiple="true"
                      :max="4">
                      <template slot="noResult">
                        <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                      </template>
                      <template slot="noOptions">
                        <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                      </template>
                      <!-- personalizziamo le opzioni selezionate (tag) -->
                      <template slot="tag" slot-scope="props">
                          <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                            <span class="custom-tag badge badge-primary mr-1">
                              <span>{{ props.option.text }}</span>
                              <span class="custom-remove" @click="props.remove(props.option)">x</span>
                          </span>
                      </template>
                      <template slot="maxElements">
                          <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                      </template>
                    </multiselect>
                  </b-form-group>
                  <!-- seleziona sub distribution -->
                  <b-form-group :label="$t('configura_lamp_modal.select_sub_distribution')" label-for="subdistribution-selection" label-class="font-weight-bolder font-italic">
                    <multiselect
                      id="subdistribution-selection"
                      v-model="selectedSubdistribution"
                      :options="subdistributionOptions"
                      :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                      :selectLabel="$t('configura_lamp_modal.press_enter')"
                      :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                      label="text"
                      track-by="value"
                      :searchable="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :max-height="200"
                      :multiple="true"
                      :max="4">
                      <template slot="noResult">
                        <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                      </template>
                      <template slot="noOptions">
                        <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                      </template>
                      <!-- personalizziamo le opzioni selezionate (tag) -->
                      <template slot="tag" slot-scope="props">
                          <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                            <span class="custom-tag badge badge-primary mr-1">
                              <span>{{ props.option.text }}</span>
                              <span class="custom-remove" @click="props.remove(props.option)">x</span>
                          </span>
                      </template>
                      <template slot="maxElements">
                          <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                      </template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group :label="$t('configura_lamp_modal.select_dynamic_light')" label-for="dynamiclight-selection" label-class="font-weight-bolder font-italic">
                    <multiselect
                      id="dynamiclight-selection"
                      v-model="selectedDynamiclight"
                      :options="dynamiclightOptions"
                      :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                      :selectLabel="$t('configura_lamp_modal.press_enter')"
                      :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                      label="text"
                      track-by="value"
                      :searchable="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :max-height="200"
                      :multiple="true"
                      :max="4">
                      <template slot="noResult">
                        <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                      </template>
                      <template slot="noOptions">
                        <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                      </template>
                      <!-- personalizziamo le opzioni selezionate (tag) -->
                      <template slot="tag" slot-scope="props">
                          <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                            <span class="custom-tag badge badge-primary mr-1">
                              <span>{{ props.option.text }}</span>
                              <span class="custom-remove" @click="props.remove(props.option)">x</span>
                          </span>
                      </template>
                      <template slot="maxElements">
                          <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                      </template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group :label="$t('configura_lamp_modal.select_manual_reset')" label-for="manualreset-selection" label-class="font-weight-bolder font-italic">
                    <multiselect
                      id="manualreset-selection"
                      v-model="selectedManualreset"
                      :options="manualresetOptions"
                      :placeholder= "$t('configura_lamp_modal.select_lssa_address')"
                      :selectLabel="$t('configura_lamp_modal.press_enter')"
                      :deselectLabel="$t('configura_lamp_modal.press_deselect')"
                      label="text"
                      track-by="value"
                      :searchable="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :max-height="200"
                      :multiple="true"
                      :max="4">
                      <template slot="noResult">
                        <span class="text-danger">{{ $t('configura_lamp_modal.no_result') }}</span>
                      </template>
                      <template slot="noOptions">
                        <span class="text-danger">{{ $t('configura_lamp_modal.list_is_empty') }}</span>
                      </template>
                      <!-- personalizziamo le opzioni selezionate (tag) -->
                      <template slot="tag" slot-scope="props">
                          <!-- ogni tag selezionato è un badge blu primary con il nome dell'opzione e una "x" per rimuoverlo -->
                            <span class="custom-tag badge badge-primary mr-1">
                              <span>{{ props.option.text }}</span>
                              <span class="custom-remove" @click="props.remove(props.option)">x</span>
                          </span>
                      </template>
                      <template slot="maxElements">
                          <span class="text-danger">{{ $t('configura_lamp_modal.max_elements') }}</span>
                      </template>
                    </multiselect>
                  </b-form-group>                                                
                </b-form-group>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
    </b-modal>

</template>

<script>
import multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vue from 'vue'
import {ClientTable} from 'vue-tables-2'
Vue.use(ClientTable)
import { mapState } from 'vuex';

export default {
  name: "GroupsSicuroCentralUnit",
  components: { multiselect },
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    //currentCent: null, //viene passata l'oggetto completo della Centrale
    cuId: null, //viene passato l'id della Centrale
    cuType: null, //viene passato il tipo della Centrale
    visible: {
      type: Boolean,
      default: false
    },
    sendAction: null,
    cmdResult: null
  },
  data() {
    return {
      maxGroups:64,
      modified: false,
      theme: 'bootstrap4',
      template: 'default',  
      cuSerial: "",
      cuDesc:"",
      footer_hide: false,
      plantUnits: this.$store.state.plantUnits,
      timerTimeout: 5,
      selectedIndex: null,
      selectedFunction: null,
      selectedTimeSwitch: null,
      selectedStairwayPushbutton: null,
      selectedLightswitch: null,
      selectedSubdistribution: null,
      selectedDynamiclight: null,
      selectedManualreset: null,
      stairwaypushbuttonDuration: null,
      spdurationOptions: Array.from({ length: 480 }, (_, i) => ({
        text: `${i + 1} min`,
        value: String(i + 1)
      })),
      showNewGroup: false,
      descGroup: null,
      waiting: false,
      editingGroup: false,
      editingGroupIndex: null,
    };
  },
  computed: {
    ...mapState( { plantUnitsShadow: state => state.plantUnits } ),

    currentCent() {
      return (this.$store.state.plantUnits || []).find(c => c.cu_id === this.cuId && c.cu_type === this.cuType);
    },
    descGroupComputed() {
      return this.descGroup;
    },
    //computed che restituisce il titolo della modal
    getTitle(){
      if (!this.currentCent || !this.currentCent.cu_type || !this.currentCent.cu_id) return '';
      return this.$t("groups_cu_modal.titlesicuro",{cent: this.currentCent.cu_type.toUpperCase() + ' - ' + this.currentCent.cu_id})
    },
    //computed che restituisce le opzioni per la funzione
    functionOptions() {
      return [
          { text: this.$t('configura_lamp_modal.time_switch'), value: 'time switch' },
          { text: this.$t('configura_lamp_modal.stairway_pushbutton'), value: 'stairway pushbutton' },
          { text: this.$t('configura_lamp_modal.switchable'), value: 'switchable' }
        ];
    },
    timeswitchOptions() {
      return [
        { text: this.$t('configura_lamp_modal.time_switch') + ' 1', value: '1' },
        { text: this.$t('configura_lamp_modal.time_switch') + ' 2', value: '2' },
        { text: this.$t('configura_lamp_modal.time_switch') + ' 3', value: '3' }
      ];
    },
    //ricerca, nella centrale corrente, gli lssa e restituisce gli input configurati come stairway pushbutton
    stairwaypushbuttonOptions() {
      var values = [];
      this.currentCent.lssa.forEach(lssa => {
        lssa.inputs.forEach(input => {
          if ((input.program != null) && (input.program.toLowerCase() == 'stairway pushbutton')) {
            values.push({
              text: this.$t('inputs_cu_modal.address') + ` ${input.address}`,
              value: String(input.address)
            });
          } 
        });
      });
      return values;
    },
    //ricerca, nella centrale corrente, gli lssa e restituisce gli input configurati come light switch nella forma {text: 'Input x', value: 'x'}
    lightswitchOptions() {
      var values = [];
      this.currentCent.lssa.forEach(lssa => {
        lssa.inputs.forEach(input => {
          if ((input.program != null) && (input.program.toLowerCase() == 'light switch')) {
            values.push({
              text: this.$t("inputs_cu_modal.address") + ` ${input.address}`,
              value: String(input.address)
            });
          }
        });
      });
      return values;
    },
    //ricerca, nella centrale corrente, gli lssa e restituisce gli address configurati come sub-distribution
    subdistributionOptions() {
      var values = [];
      this.currentCent.lssa.forEach(lssa => {
        lssa.inputs.forEach(input => {
          if ((input.program != null) && (input.program.toLowerCase() == 'sub distribution')) {
            values.push({
              text: this.$t("inputs_cu_modal.address") + ` ${input.address}`,
              value: String(input.address)
            });
          }
        });
      });
      return values;
    },
    // ricerca, nella centrale corrente, gli lssa e resttuisce gli input configurati come dynamic light
    dynamiclightOptions() {
      var values = [];
      this.currentCent.lssa.forEach(lssa => {
        lssa.inputs.forEach(input => {
          if ((input.program != null) && (input.program.toLowerCase() == 'dynamic light')) {
            values.push({
              text: this.$t("inputs_cu_modal.address") + ` ${input.address}`,
              value: String(input.address)
            });
          } 
        });
      });
      return values;
    },
    // ricerca, nella centrale corrente, gli lssa e resttuisce gli input configurati come manual reset
    manualresetOptions() {
      var values = [];
      this.currentCent.lssa.forEach(lssa => {
        lssa.inputs.forEach(input => {
          if ((input.program != null) && (input.program.toLowerCase() == 'manual reset')) {
            values.push({
              text: this.$t("inputs_cu_modal.address") + ` ${input.address}`,
              value: String(input.address)
            });
          } 
        });
      });
      return values;
    },
    groupOptions() {
      var values = Array.from({ length: this.maxGroups }, (_, i) => ({
        text: `${i + 1}`,
        value: String(i + 1)
      }));
      //devo togliere gli indici già presenti
      if (this.currentCent == null || this.currentCent.groups == null) return values;
      else {
        this.currentCent.groups.forEach(group => {
          values = values.filter(value => Number(value.value) !== Number(group.groupId));
        });
      }
      return values;
    },
  },
  watch: {
    //quando cambia currentCent.groups, significa che l'operazione di salvataggio è terminata
    'currentCent.groups': {
      handler(newVal, oldVal) {
        console.log("!!!GroupsSicuroCentralUnit, currentGroup: ", newVal);
        this.waiting = false;
      },
      deep: true // Add this if you want to watch nested changes
    }
  },
  methods: {
    //se il comando è fallito, esco dalla modalità waiting
    verificaResponse() {
      if (this.cmdResult === 'fail') {
        this.waiting = false;
      }
    },
    //funzione che a seconda del gruppo selezionato imposta la description
    imponiDesc(val) {
      if (val == null) {
        this.descGroup = null;
      } else {
        this.descGroup = `Group ${val.value}`;
      }
    },
    //funzione che restituisce le opzioni per i gruppi quando si modifica il gruppo stesso, aggiungendo anche il gruppo che si vorrebbe cambiare
    getGroupOptions(value) {
      let options = this.groupOptions.slice(); // crea una copia dell'array delle opzioni
      if (value !== null) {
        options.push({ text: String(Number(value)), value: Number(value) });
        options.sort((a, b) => a.value - b.value); // ordina le opzioni per valore numerico
      }   
      return options;
    },

    hide() {
      this.$emit("hide");
    },

    change(visible) {
      this.$emit("change", visible);
    },

    //apre la modal di inserimento di un nuovo gruppo
    addNewGroup() {
      console.log("premuto pulsante 'addNewGroup'");
      this.showNewGroup = true;
    },
    //funzione che gestisce la chiusura della modal quando si preme la "x" o il pulsante Cancel, chiudendo solo il modal figlio
    handleCancel(evt) {
      console.log("handleCancel, evt: ", evt);
      this.showNewGroup = false;
    },
    // Abilita il pulsante OK solo se lo stato è attivo e sono state selezionate le opzioni necessarie
    disabilitaOk() {      
      return  (this.selectedFunction === null || 
                (this.selectedFunction === 'time switch' && this.selectedTimeSwitch === null) || 
                (this.selectedFunction === 'stairway pushbutton' && (this.selectedStairwayPushbutton === null || this.stairwaypushbuttonDuration === null)) || 
                (this.selectedFunction === 'switchable' && (this.selectedLightswitch === null && this.selectedSubdistribution === null && this.selectedDynamiclight === null && this.selectedManualreset === null)));
    },
    //La modal viene creato all'inizio di Centrali.vue e poi il contenuto, props comprese, vengono caricate dinamicamente
    //con possibili problemi di rendering. Per questo motivo, ogni volta che il modal viene mostrato, si reimpostano
    //le variabili di stato
    inizializzaStato() {
      this.selectedIndex= null;
      this.selectedFunction = null;
      this.selectedTimeSwitch = null;
      this.selectedStairwayPushbutton = null;
      this.selectedLightswitch = null;
      this.selectedSubdistribution = null;
      this.selectedDynamiclight = null;
      this.selectedManualreset = null;
      this.stairwaypushbuttonDuration = null;
      this.descGroup = null;
      this.waiting = false;
    },
    //funzione che viene invocata quando la modal viene chiusa e chiude solo il modal figlio
    onModalNewGroupHide(bvEvent) {
      //console.log("onModalNewGroupHide, bvEvent: ", bvEvent);
      this.showNewGroup = false;
    },
    //funzione che elimina un gruppo usando la funzione 'none'
    deleteGroup(group) {
      console.log("deleteGroup, group: ", Number(group.groupId));
      //occorre verificare se ci sono lampade che appartengono a questo gruppo
      let lampsGroup=[];
      this.currentCent.ak.forEach(ak => {
        ak.lines.forEach(line => {
          line.lamps.forEach(lamp => {
            lamp.groups.forEach(gr => {
              if (Number(gr) === Number(group.groupId)) {
                lampsGroup.push(lamp);
              }
            });
          });
        });
      });
      console.log("deleteGroup, lampsGroup: ", lampsGroup);
      if (lampsGroup.length > 0) {
        //ci sono lampade che appartengono a questo gruppo, non si può eliminare
        this.$bvModal.msgBoxOk(this.$t('groups_cu_modal.cannot_delete_group'), {
          title: this.$t("groups_cu_modal.delete_forbidden"),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          // okTitle: this.$t("groups_cu_modal.ok_button"),
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true,
        }).catch(err => {
          console.error(err);
        });
      } else {
          //prima chiedo conferma con msgBox
          this.$bvModal.msgBoxConfirm(this.$t('sicuro.are_you_sure'), {
            title: this.$t("sicuro.delete_group"),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: this.$t("settings.delete"),
            // cancelVariant: 'dark',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          }).then((risp) => {
            if (risp == true) {
              var params = {};
              params.command = "configGruppi";
              params.cu_type = this.currentCent.cu_type;
              params.cu_id = this.currentCent.cu_id;
              params.group_index = group.groupId;
              params.group_desc = group.group_desc;
              params.function = "none";

              console.log("deleteGroup, params: ", params);
              this.waiting = true;
              this.sendAction(params);
              //Hide the modal manually
              this.$nextTick(() => {
                  this.$refs.modal.hide()
              }) 
            }}).catch(err => {
              console.error(err);
            }
          );
      }

    },
    //funzione che inizializza le variabili di selezione con i valori attualmente configurati, eppoi setta a true la variabile configLssa
    //che rende configurabili le proprietà 'program', 'ingresso' e 'negated'
    modifyGroup(group) {
      this.editingGroup = true;
      this.editingGroupIndex = group.groupId;
      this.selectedIndex = this.getGroupOptions(group.groupId).find(option => option.value == String(group.groupId));
      this.descGroup = group.group_desc;
      this.selectedFunction = group.program.toLowerCase();
      switch (this.selectedFunction) {
        case 'time switch':
          this.selectedTimeSwitch = this.timeswitchOptions.find(option => option.value == String(group.subProgram.time_switch)).value;
          break;
        case 'stairway pushbutton':
          this.selectedStairwayPushbutton = this.stairwaypushbuttonOptions.find(option => option.value == String(group.subProgram.stairway_pushbutton));
          this.stairwaypushbuttonDuration = this.spdurationOptions.find(option => option.value == String(group.subProgram.time));
          break;
        case 'switchable':
          // recupera gli input configurati
          this.selectedLightswitch = [];
          this.selectedSubdistribution = [];
          this.selectedDynamiclight = [];
          this.selectedManualreset = [];
          for (let i = 1; i <= 4; i++) {
            if (group.subProgram[`light_switch_${i}`]) {
              let lsOption = this.lightswitchOptions.find(option => option.value === String(group.subProgram[`light_switch_${i}`]));
              if (lsOption) {
                this.selectedLightswitch.push(lsOption);
              }
            }
            if (group.subProgram[`sub_distribution_${i}`]) {
              let sdOption = this.subdistributionOptions.find(option => option.value === String(group.subProgram[`sub_distribution_${i}`]));
              if (sdOption) {
                this.selectedSubdistribution.push(sdOption);
              }
            }
            if (group.subProgram[`dynamic_light_${i}`]) {
              let dlOption = this.dynamiclightOptions.find(option => option.value === String(group.subProgram[`dynamic_light_${i}`]));
              if (dlOption) {
                this.selectedDynamiclight.push(dlOption);
              }
            }
            if (group.subProgram[`manual_reset_${i}`]) {
              let mrOption = this.manualresetOptions.find(option => option.value === String(group.subProgram[`manual_reset_${i}`]));
              if (mrOption) {
                this.selectedManualreset.push(mrOption);
              }
            }
          }
      }
    },

    //funzione che evita la chiusura della modal e prepara i dati da inviare a Centrale.vue
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveParam();
    },
    saveGroup(group) {
      console.log("saveGroup, group: ", group);
      this.editingGroup = false;
      this.saveParam();
    },
    //prepara i parametri e invoca la funzione passata da Centrali.vue per inviare il comando alla centrale
    saveParam() 
    { 
      console.log("saveParam, currentCent: ", this.currentCent);
      var params ={};
      //parametri comuni
      params.command = "configGruppi";
      params.cu_type = this.currentCent.cu_type;
      params.cu_id = this.currentCent.cu_id;
      params.group_index = this.selectedIndex.value;
      params.group_desc = this.descGroup;
      params.function = this.selectedFunction;
      switch (params.function) {
        case 'time switch':
          params.ts = this.selectedTimeSwitch;
          break;
        case 'stairway pushbutton':
          params.sp = this.selectedStairwayPushbutton.value;
          params.duration = this.stairwaypushbuttonDuration.value
          break;
        case 'switchable':
          if (this.selectedLightswitch !== null) {
            for (let i = 0; i < this.selectedLightswitch.length; i++) {
              params[`ls_${i+1}`] = this.selectedLightswitch[i].value;
            }
          }
          if (this.selectedSubdistribution !== null) {
            for (let i = 0; i < this.selectedSubdistribution.length; i++) {
              params[`sd_${i+1}`] = this.selectedSubdistribution[i].value;
            }
          }
          if (this.selectedDynamiclight !== null) {
            for (let i = 0; i < this.selectedDynamiclight.length; i++) {
              params[`dl_${i+1}`] = this.selectedDynamiclight[i].value;
            }
          }
          if (this.selectedManualreset !== null) {
            for (let i = 0; i < this.selectedManualreset.length; i++) {
              params[`mr_${i+1}`] = this.selectedManualreset[i].value;
            }
          }
          break;
        default:
          break;
      }
      console.log("GroupConfig, params: ", params);
      this.waiting = true;
      this.sendAction(params);

      //Hide the modal manually
      this.$nextTick(() => {
          this.$refs.modal.hide()
      })     
    },       
  }
};
</script>

<style>


</style>